import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  referralSentContainer: {
    [theme.breakpoints.down('lg')]: {
      margin: 30,
      width: '100%'
    },
    [theme.breakpoints.down('md')]: {
      margin: 15
    }
  },
  referralSentCopy: {
    display: 'block',
    justifyContent: 'center',
    padding: 0,
    textAlign: 'center'
  },
  referralLabel: {
    marginBottom: 30
  },
  referralHeading: {
    marginBottom: 30
  },
  referralSentButtons: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse'
    }
  },
  button: {
    marginRight: 30,
    width: 200,
    '&:last-child': {
      marginRight: 0
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
      marginRight: 0,
      width: '100%'
    }
  },
  mailIcon: {
    marginTop: 45
  }
});
